import React, {useMemo} from "react";
import {useNavigate} from "react-router-dom";
import {usePostRegistrationMutation} from "./reg_api";
import SnackError from "../../components/SnackError";
import {TablesInsert} from "../../apitypes";
import RegForm, {RegData} from "./RegForm";
import {FormikHelpers} from "formik";
import {Box} from "@mui/material";

export default () => {
    const navigate = useNavigate();
    const [saveRegistration, {error}] = usePostRegistrationMutation();

    const onSubmit = async function (values: RegData, helper: FormikHelpers<any>) {
        const data: TablesInsert<"registration"> = {
            WorkOrderID: values.workOrder?.id || null,
            WorkerID: values.worker?.id || null,
            MachineID: values.machine?.id || null,
            OperationID: values.workTask?.id || null,
            StartTime: values.StartTime,
            EndTime: values.EndTime || null,
            Status: values.EndTime ? "RegFinished" : "RegNew",
            ProductID: values.product?.id || null,
        }
        const res = await saveRegistration(data);
        if ("data" in res) {
            navigate(-1);
        }
        helper.setSubmitting(false);
    }

    const reg: RegData = useMemo((): RegData => {
        return {
            StartTime: new Date().toISOString(),
            EndTime: new Date().toISOString(),
            worker: null,
            workOrder: null,
            workTask: null,
            workItem: null,
            machine: null,
            Status: "RegFinished",
            product: null,
            interruptLine: [],
            profile: null,
            ElapsedTime: 0,
            CreatedByID: null,
            MachineID: null,
            OperationID: null,
            WorkerID: null,
            WorkOrderID: null,
            WorkRefID: null,
            ProductID: null,
            Quantity: 0,
            ScrapQuantity: 0,
        }
    }, [])

    return <Box sx={{mt:"1em"}}>
        <SnackError error={error}/>
        <RegForm reg={reg} onSubmit={onSubmit} onCancel={() => navigate(-1)}/>
    </Box>;
};


